<template>
  <section>
    <NavBar />
    <Loader v-if="showLoader"></Loader>
    <Content />
    <router-view />
    <Footer />
  </section>
</template>

<script>
  import NavBar from "../components/Navbar";
  import Content from "../components/Content";
  import Footer from "../components/Footer";
  import Loader from "../components/Loader.vue";
  import { mapState } from "vuex";
  import { AUTO_LOGIN_ACTION } from "../store/storeconstants";

  export default {
    name: "DashBoard",
    computed: {
      ...mapState({
        showLoader: (state) => state.showLoader,
        autoLogout: (state) => state.auth.autoLogout,
      }),
    },
    watch: {
      autoLogout(curValue, oldValue) {
        if (curValue && curValue != oldValue) {
          this.$router.replace("/Login");
        }
      },
    },
    components: {
      NavBar,
      Content,
      Footer,
      Loader,
    },
    created() {
      this.$store.dispatch(`auth/${AUTO_LOGIN_ACTION}`);
    },
  };
</script>